export default __webpack_public_path__ + "static/media/291.bbf22f65.png";